
/*** this file is auto-generated.
for more information visit tools/build-config
***/

import { TEST_CONFIG_PART } from './partials';
import { Config } from './interfaces/config.interface'

export const CONFIG: Config = { ...TEST_CONFIG_PART } as Config;
